<template>
  <svg role="presentation" class="icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path class="cls-1" d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" />
    <path class="cls-1" d="M17.4998 17.5L13.9165 13.9167" />
  </svg>
</template>
<script>
export default {
  name: 'SearchIcon'
}
</script>
<style lang="scss" scoped>
.icon {
  height: 2rem;
  width: 2rem;
}

.cls-1 {
  fill: none;
  stroke: var(--_zenith-header-text-link, var(--zenith-header-text-link));
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
